import { Dispatch, SetStateAction, useState } from "react";
import { Box, Button } from "@mui/material";
import AddIcon from "@mui/icons-material/Add";
import SearchBar from "../../components/SearchBar";
import AddCategory from "../../Modals/addCategory";
import { isValidInput } from "../../utils/validations";
import usePermission from "../../hooks/usePermission";
import useTranslation from "../../hooks/traslation";

type props = {
  open: boolean;
  name: string;
  price: string;
  image: string;
  selectedId: string;
  setSelectedId: Dispatch<SetStateAction<string>>;
  setImage: Dispatch<SetStateAction<string>>;
  setName: Dispatch<SetStateAction<string>>;
  setPrice: Dispatch<SetStateAction<string>>;
  handleSubmit: () => void;
  setOpen: Dispatch<SetStateAction<boolean>>;
  handleProfileUpload: (
    event: React.ChangeEvent<HTMLInputElement>
  ) => Promise<void>;
  setDebouncedSearchTerm: Dispatch<SetStateAction<string>>;
  setSearchTerm: Dispatch<SetStateAction<string>>;
  searchTerm: string;
  setDescription: Dispatch<SetStateAction<string>>;
  description: string;
  setDescriptionAr: Dispatch<SetStateAction<string>>;
  setNameAr: Dispatch<SetStateAction<string>>;
  nameAr: string;
  descriptionAr: string;
};

const CategoryTopbar = ({
  open,
  setOpen,
  price,
  setPrice,
  name,
  setName,
  handleSubmit,
  image,
  setImage,
  handleProfileUpload,
  selectedId,
  setSelectedId,
  setDebouncedSearchTerm,
  setSearchTerm,
  searchTerm,
  description,
  setDescription,
  descriptionAr,
  nameAr,
  setDescriptionAr,
  setNameAr,
}: props) => {
  const { isAdd, isDelete } = usePermission({
    label: "Manage Categories",
    page_permission: "isView",
  });

  const handleCloseModal = () => {
    setOpen(false);
  };

  const translate = useTranslation();

  return (
    <>
      <div className="table_header">
        <div className="left_s">
          <Box className="search_box">
            <SearchBar
              placeholder={translate?.user?.SearchHere}
              searchTerm={searchTerm}
              setDebouncedSearchTerm={setDebouncedSearchTerm}
              value={searchTerm}
              onCross={() => setSearchTerm("")}
              onChange={(val: any) => {
                if (isValidInput(val.target.value)) {
                  setSearchTerm(val.target.value);
                }
              }}
            />
          </Box>
        </div>
        {isAdd ? (
          <div className="right_s">
            <Button
              className="btn btn_primary"
              onClick={() => {
                setImage("");
                setName("");
                setPrice("");
                setSelectedId("");
                setOpen(true);
                setNameAr("");
                setDescription("");
                setDescriptionAr("");
              }}
            >
              <AddIcon /> {translate?.main?.AddCategory}
            </Button>
          </div>
        ) : null}
      </div>

      <AddCategory
        image={image}
        setImage={setImage}
        open={open}
        onClose={handleCloseModal}
        setOpen={setOpen}
        name={name}
        setName={setName}
        price={price}
        setPrice={setPrice}
        handleSubmit={handleSubmit}
        handleProfileUpload={handleProfileUpload}
        selectedId={selectedId}
        setSelectedId={setSelectedId}
        setDescription={setDescription}
        description={description}
        setDescriptionAr={setDescriptionAr}
        descriptionAr={descriptionAr}
        setNameAr={setNameAr}
        nameAr={nameAr}
      />
    </>
  );
};

export default CategoryTopbar;
